import type { FirebaseConfigType } from './type';
import { LocalOrigins } from '../localOrigins';

export const FirebaseConfig: FirebaseConfigType = {
  apiKey: 'AIzaSyBjey37E19jOqMbmQv5ZKM2GdDatZzA93E',
  authDomain: [
    'balus-local.dev.levii.co.jp',
    'admin-balus-local.dev.levii.co.jp',
    LocalOrigins.cloudWebappHost,
    LocalOrigins.cloudAdminWebappHost,
  ].includes(location.host)
    ? location.host
    : 'balus-local.dev.levii.co.jp',
  databaseURL: 'https://levii-balus-local.firebaseio.com',
  projectId: 'levii-balus-local',
  storageBucket: 'levii-balus-local.appspot.com',
  messagingSenderId: '1038545176134',
  appId: '1:1038545176134:web:b4269e2f44ebbbdd46ec47',
  measurementId: 'G-K5VGKRTQJT',
  actionLogDatabaseURL: 'https://levii-balus-local-action-log-rtdb.firebaseio.com',
};
